<template>
  <div id="pending-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        ref="searchItem"
        config-module="90200"
        :show-simple="true"
        :search-item-code="$t('SeaExport.PickingList')"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('SeaExport.QuickSearchPickingOrderNo')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <el-button no="PickingCompleted" type="primary" @click="pickingOrder(1)">{{ $t('SeaExport.PickingCompleted') }}</el-button>
          <el-button no="CancelPickingCompleted" type="primary" @click="pickingOrder(0)">{{ $t('SeaExport.CancelPickingCompleted') }}</el-button>
          <el-button no="Edit" type="primary" @click="toEdit()">{{ $t('SeaExport.Edit') }}</el-button>
          <el-button no="Delete" type="danger" @click="toDelete()">{{ $t('SeaExport.Delete') }}</el-button>
          <el-button no="expandAll" type="primary" @click="expandAll()">{{ $t('queryJob.expandAll') }}</el-button>
          <el-button no="putItAllAway" type="primary" @click="putItAllAway()">{{ $t('queryJob.putItAllAway') }}</el-button>
          <!--打印-->
          <el-button no="print" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="min-height:550px">
        <cargo-ag-grid
          config-module="90201"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="90201"
          :total="total"
          :page.sync="filterJson.pageNum"
          :limit.sync="filterJson.pageSize"
          @pagination="toQueryByPage"
        />
      </div>
    </div>
    <!--拣货单明细-->
    <picking-order-dialog
      ref="pickingOrderDialog"
      :open-imperial="openImperial"
      @close="pickingOrderDialog.visible=false"
      @refresh="toQuery"
    />
  </div>
</template>

<script>

import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import {
  pickingOrderStatus,
  deletePickingOrder,
  pickingAdvancedQuery
} from '@/api/warehouseIn/warehouseIn'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import { stringToBool } from '@/utils/commonUtil'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import PickingOrderDialog from '@/views/cargo/v0/AirExport/PreWarehouseOutbound/components/pickingOrderDialog.vue'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { IMPERIAL_6 } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'PickingList',
  components: { PickingOrderDialog, searchItem },
  data() {
    return {
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        treeData: true,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.PickingOrderNumber'),
          colId: 'pickingOrderNo',
          field: 'pickingOrderNo',
          width: 140,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: params => {
            if (params.data && params.data.hasOwnProperty('dataType') && Number(params.data.dataType) === 1) {
              return true
            }
            return false
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              const curData = params.data
              if (curData && curData.hasOwnProperty('dataType') && Number(curData.dataType) === 1) {
                const pickingOrderNo = ColumnUtils.mawbNoLabelFun(curData.pickingOrderNo)
                return `<span>${pickingOrderNo}</span>`
              }
              return `<span></span>`
            }
          }
        }
      },
      gridParams: {},
      customSearchItems: [],
      rowData: [],
      isAdvancedQuery: false, // 是否为高级查询
      total: 0,
      filterJson: {
        pageNum: 1,
        pageSize: 10
      },
      filter: {
        pageNum: 1,
        pageSize: 10,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: []
      },
      airMblDisplayStyle: false, // 空运主单号格式
      openImperial: false, // 英制单位
      pickingOrderDialog: {
        visible: false
      }
    }
  },
  computed: {
    columnDefs() {
      const list = [
        {
          headerName: this.$t('SeaExport.JobNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 120,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.BoardNumber'),
          field: 'palletNumber',
          colId: 'palletNumber',
          width: 140,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 3) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.PickingStatus'),
          field: 'pickingStatus',
          colId: 'pickingStatus',
          width: 120,
          cellRenderer: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 1) {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value === 1))
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.MasterBillNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 120,
          cellRenderer: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return ColumnUtils.mawbNoLabelFun(params.value, this.airMblDisplayStyle)
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hbl',
          colId: 'hbl',
          width: 120,
          cellRenderer: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Warehouse'),
          field: 'warehouseName',
          colId: 'warehouseName',
          width: 120,
          cellRenderer: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 1) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.DeliveryStation'),
          field: 'deliveryStation',
          colId: 'deliveryStation',
          width: 120,
          cellRenderer: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 1) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.Flight'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 120,
          cellRenderer: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FlightDate'),
          field: 'voyageFlightDate',
          colId: 'voyageFlightDate',
          width: 120,
          cellRenderer: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          colId: 'quantity',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          colId: 'weight',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          colId: 'cubage',
          width: 120
        }
      ]
      if (this.openImperial) {
        list.push({
          headerName: this.$t('SeaExport.Weight') + 'LB',
          field: 'weightImperial',
          colId: 'weightImperial',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Cubage') + 'CFT',
          field: 'cubAgeImperial',
          colId: 'cubAgeImperial',
          width: 100
        })
      }
      return list
    }
  },
  created() {
    this.initConfig()
  },
  methods: {
    // 初始化一些 config表的配置信息
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.airMblDisplayStyle = Number(cache.config.get('AirMblDisplayStyle')) === 1
      this.customSearchItems = await this.getCustomSearchItems()
      await JobUtils.initImperialData(IMPERIAL_6.code).then(r => {
        this.openImperial = r
      })
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      this.filter.pageNum = 1
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.filter.pickingOrderNo = ''
      this.filter.conditions = []
      this.filter.lob = SystemConstants.AE.code
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
        this.filter.conditions = [... data]
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.pageNum = this.filterJson.pageNum
      this.filter.pageSize = this.filterJson.pageSize
      this.loading = getLoading4Cxt()
      pickingAdvancedQuery(this.filter).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.loading = getLoading4Cxt()
      if (typeof keyword !== 'undefined') {
        this.filter.pickingOrderNo = keyword.trim()
        this.filter.pageNum = 1
        this.filter.lob = SystemConstants.AE.code
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      const conditions = []
      this.filter.conditions = conditions
      pickingAdvancedQuery(this.filter).then(res =>
        this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filterJson.pageNum = res.data.pageNum
      this.filterJson.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.selectedData = null
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    async getCustomSearchItems() {
      const defaultSearchFields = []
      const operations = getCacheListByKey(basicCacheKeys.basic_data_AirportCargoTerminal)
      const warehouseOperations = operations.filter(data => data.dataType === 1)
        .map(item => ({
          code: item.uuid,
          chineseName: item.warehouseName,
          englishName: item.warehouseName
        }))
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'airExportJob.FRONT_END_WAREHOUSE_OPERATION'
      searchField.itemLabel = 'CargoMsg.Cargo_Warehouse'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.tagName = 'warehouseName'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = warehouseOperations
      defaultSearchFields.push(searchField.formatObj2Json())

      const stationOperations = operations.filter(data => data.dataType === 0)
        .map(item => ({
          code: item.uuid,
          chineseName: item.warehouseName,
          englishName: item.warehouseName
        }))
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'airExportJob.CARGO_TERMINAL_OPERATION'
      searchField.itemLabel = 'SeaExport.FreightStation'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.tagName = 'warehouseName'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = stationOperations
      defaultSearchFields.push(searchField.formatObj2Json())

      // 拣货状态
      searchField = new AdvancedSearchField()
      searchField.multiple = 0
      searchField.defaultValue = ''
      searchField.itemLabel = 'SeaExport.PickingStatus'
      searchField.itemName = 'pickingOrder.PICKING_STATUS'
      searchField.itemValue = ''
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.lock = false
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    // 1：拣货完成 0：取消拣货完成
    pickingOrder(status) {
      const selectedRows = this.gridApi.getSelectedRows()
      const rows = selectedRows.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1))
      if (rows.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const pickingOrderKeys = []
      for (const item of rows) {
        if (!pickingOrderKeys.includes(item.pickingOrderUuid)) {
          pickingOrderKeys.push(item.pickingOrderUuid)
        }
      }
      this.loading = getLoading4Cxt()
      pickingOrderStatus({ pickingOrderKeys: pickingOrderKeys, statusType: 0, pickingStatus: status }).then(res => {
        if (res.ok) {
          this.$message.success(status === 1 ? this.$t('SeaExport.PickingCompleted') : this.$t('SeaExport.CancelPickingCompleted'))
        }
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 编辑拣货单
    async toEdit() {
      const selectedRows = this.gridApi.getSelectedRows()
      const rows = selectedRows.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1))
      if (rows.length !== 1) {
        this.$message.warning(this.$t('SeaExport.PleaseSelectCorrespondPickingList'))
        return
      }
      for (const item of rows) {
        if (item.pickingStatus === 1) {
          this.$message.warning(this.$t('SeaExport.NotAllowEditPickingCompletion'))
          return
        }
      }
      const pickingOrderKey = rows[0].pickingOrderUuid
      const detailRows = selectedRows.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 3) && pickingOrderKey === p.pickingOrderUuid) || []
      const pickingOrder = { pickingOrderKey: pickingOrderKey, deliveryStation: rows[0].deliveryStation, warehouseName: rows[0].warehouseName }
      await this.$refs.pickingOrderDialog.onShow(pickingOrder, detailRows)
    },
    // 删除拣货单
    toDelete() {
      const selectedRows = this.gridApi.getSelectedRows()
      const rows = selectedRows.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1))
      if (rows.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      for (const item of rows) {
        if (item.pickingStatus === 1) {
          this.$message.warning(this.$t('SeaExport.NotAllowDeletePickingCompletion'))
          return
        }
      }
      const pickingOrderKeys = []
      for (const item of rows) {
        if (!pickingOrderKeys.includes(item.pickingOrderUuid)) {
          pickingOrderKeys.push(item.pickingOrderUuid)
        }
      }
      this.loading = getLoading4Cxt()
      deletePickingOrder({ pickingOrderKeys: pickingOrderKeys }).then(res => {
        if (res.ok) {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteFailed'))
        }
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    expandAll() {
      this.gridOptions.groupDefaultExpanded = 3
      this.gridApi.expandAll()
    },
    putItAllAway() {
      this.gridOptions.groupDefaultExpanded = 0
      this.gridApi.collapseAll()
    },
    // 打印
    onPrintHandler() {
      const warehouseInUuids = []
      const pickingOrderKeys = []
      const selectedRows = this.gridApi.getSelectedRows()
      for (const selectedRow of selectedRows) {
        if (selectedRow.dataType === 3 && !warehouseInUuids.includes(selectedRow.warehouseInUuid)) {
          warehouseInUuids.push(selectedRow.warehouseInUuid)
          pickingOrderKeys.push(selectedRow.pickingOrderUuid)
        }
      }
      if (!warehouseInUuids || warehouseInUuids.length === 0) {
        this.$message.info(this.$t('Message.PleaseSelectTheDesiredPrintInformation'))
        return
      }
      this.$emit('print', warehouseInUuids, pickingOrderKeys)
    }
  }
}
</script>

<style scoped>

</style>
